import React from 'react'
// Components
import { ImageBackgroundDetail } from '~2023/components/ImageBackground'

const FandomCardDetail = ({ item }) => {
  return (
    <>
      <ImageBackgroundDetail
        imageDetail={item.imageDetail}
        imageDetailDesktop={item.imageDetailDesktop}
        imageDetailMobile={item.imageDetailMobile}
        imageDetailPlaceholder={item.imageDetailPlaceholder}
        imageDetailTablet={item.imageDetailTablet}
      />
    </>
  )
}

export default FandomCardDetail
